import moment from "moment/moment";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { SnaphotApi as SnaphotApiProd } from "../services/akfenservicesprod/api";
import { Line } from "react-chartjs-2";
import { Link } from "react-router-dom";
import "chart.js/auto";
import "chartjs-adapter-date-fns";
import RasyonetLine from "../assets/images/rasyonet-line.png";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import * as $ from "jquery";
import CalendarComponent from "../components/_Helper/Calendar/calendar";

function Snapshot() {
  //#region API
  const snaphotProdApi = new SnaphotApiProd({
    username: "akfeninsaat-avocet",
    password: "G*W8Cc/k?zK&Pp9",
  });

  let api = snaphotProdApi;

  //#endregion

  //#region Page Property
  const { t, i18n } = useTranslation();
  const chartRef = useRef();
  const navChartRef = useRef();
  //#endregion

  //#region Frequencies
  const frequencies = [
    { value: "1w", label: t("weekly") },
    { value: "1m", label: t("month") },
    { value: "3m", label: t("month") },
    { value: "6m", label: t("month") },
    { value: "1y", label: "1y" },
    { value: "2y", label: "2y" },
    { value: "3y", label: "3y" },
    { value: "5y", label: "5y" },
  ];
  //#endregion

  //#region UseState
    const [newsData, setNewsData] = useState([]);
  const [newsStatu, setNewsStatu] = useState(true);
  const [startDate, setStartDate] = useState(() => {
    let date = new Date();
    date.setMonth(date.getMonth() - 1);
    date.setHours(0, 0, 0, 0);
    return date;
  });
  const [endDate, setEndDate] = useState(
    new Date(new Date().setHours(0, 0, 0, 0))
  );
  const [visible, setVisible] = useState(false);
  const [date, setDate] = useState(moment(new Date()).format("DD.MM.YYYY"));
  const [frequency, setFrequency] = useState("1y");
  const [chartStatu, setChartStatu] = useState(true);
  const [indexData, setIndexData] = useState([]);
  const [priceGridData, setPriceGridData] = useState([]);
  const [selectedLang, setSelectedLang] = useState("");
  const [companyInformation, setCompanyInformation] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState();
  const [currencies, setCurrencies] = useState();
  const [navData, setNavData] = useState({
    datasets: [
      {
        fill: false,
        borderColor: "#E1E2E2",
        borderWidth: 1,
        pointRadius: 0,
      },
    ],
  });
  const [chartData, setChartData] = useState({
    datasets: [
      {
        fill: false,
        borderColor: "#E1E2E2",
        borderWidth: 1,
        pointRadius: 0,
      },
    ],
  });

  const [chartOptions, setChartOptions] = useState({
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        intersect: false,
        mode: "index",
      },
    },
    scales: {
      x: {
        type: "time",
        distribution: "linear",
        grid: {
          display: false,
        },
        ticks: {
          font: {
            color: "#000",
            size: 13,
          },
        },
        time: {
          unit: "month",
        },
      },
      y: {
        grid: {
          color: "#E1E2E2",
        },
        ticks: {
          font: {
            color: "#000",
            size: 12,
          },
          padding: 15,
        },
        beginAtZero: true,
      },
    },
  });

  const navChartOptions = {
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        intersect: false,
        mode: "index",
        callbacks: {
          label: (context) => {
            const value = context.parsed.y;
            return `${t("netAssetValueTooltipText")}: ${value.toFixed(2)}`;
          },
        },
      },
    },
    scales: {
      x: {
        distribution: "linear",
        grid: {
          display: false,
        },
        ticks: {
          font: {
            color: "#000",
            size: 13,
          },
        },
      },
      y: {
        grid: {
          color: "#E1E2E2",
        },
        ticks: {
          font: {
            color: "#000",
            size: 12,
          },
          padding: 15,
        },
        beginAtZero: true,
      },
    },
  };

  //#endregion

  //#region Format Number
  const formatNumber = (number) => {
    
    return number.toLocaleString("en-US", {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

    const formatNumberDigits = (number) => {
    
    return number.toLocaleString("en-US", {
      style: "decimal",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  };
  //#endregion

  //#region Load Data

  const openNewsDetail = (item) => {
    if (api !== undefined && api !== "") {
      api.snaphotNewsDetailGet(item.id).then((response) => {
        if (response.status === 200) {
          let datas = response.data;
          setVisible(true);

          setTimeout(() => {
            let content = datas["body"];
            var parser = new DOMParser();
            var htmlDoc = parser.parseFromString(content, "text/html");

            $(".fa-question-circle", htmlDoc).css("display", "none");
            $("iframe", htmlDoc).each(function (index, element) {
              var iframe = $(this)[index];

              var iframeSrc = $(iframe).attr("src");

              if (iframeSrc.indexOf("embed") == -1) {
                if (iframeSrc.indexOf("youtu.be") != -1) {
                  let youtubeSrcId =
                    iframeSrc.split("/")[iframeSrc.split("/").length - 1];

                  $(iframe).attr(
                    "src",
                    "https://www.youtube.com/embed/" + youtubeSrcId
                  );
                } else if (iframeSrc.indexOf("youtube.com") != -1) {
                  var youtubeParams = iframeSrc.split("?")[1];

                  var urlParams = new URLSearchParams(youtubeParams);
                  let youtubeSrcId = urlParams.get("v");

                  $(iframe).attr(
                    "src",
                    "https://www.youtube.com/embed/" + youtubeSrcId
                  );
                }
              }
            });

            var stringHtmlContent = $("body", htmlDoc).html();

            if (stringHtmlContent.substring(0, 5) == "<?xml") {
              $("#newsModalBody").append(stringHtmlContent.split("</head>")[1]);
              $("#newsModalBody .fa-question-circle").remove();
              $("#newsModalBody .gwt-Label").css("text-align", "left");
            } else {
              $("#newsModalBody").append(stringHtmlContent);
            }

            $("#newsModalHeader").html(item.header);
            $("#newsModalHeaderDate").html(
              moment.utc(item.date).local().format("MM/DD/YYYY HH:mm:ss")
            );
          }, 100);
        }
      });
    }
  };

  const indexCoverageInformation = () => {
    if (api !== undefined && api !== "") {
      api
        .snaphotIndexWeightGet("sec.101.837", selectedLang)
        .then((response) => {
          console.log("res: ", response);
          if (response.status === 200) {
            let datas = response.data;
            setIndexData(datas);
          }
        });
    }
  };

  const priceChartData = (frequency) => {
    let fr = "OneYear";
    if (frequency !== undefined && frequency !== null && frequency !== "") {
      if (frequency === "1w") fr = "OneWeek";
      else if (frequency === "1m") fr = "OneMonth";
      else if (frequency === "3m") fr = "ThreeMonth";
      else if (frequency === "6m") fr = "SixMonth";
      else if (frequency === "1y") fr = "OneYear";
      else if (frequency === "2y") fr = "TwoYear";
      else if (frequency === "3y") fr = "ThreeYear";
      else if (frequency === "5y") fr = "FiveYear";
    }

    if (api !== undefined && api !== "") {
      api.snaphotPriceChartGet("sec.101.837", fr).then((response) => {
        if (response.status === 200) {
          let datas = response.data;
          let data1 = [];
          let label = [];

          for (var i = 0; i < datas.length; i++) {
            data1.push(parseFloat(datas[i]["value"]).toFixed(2));
            label.push(
              moment(
                new Date(datas[i]["date"].toString().split("T")[0])
              ).format("yyyy-MM-DD")
            );
          }

          const newChartData = {
            labels: label,
            datasets: [
              {
                data: data1,
                fill: false,
                borderColor: "#1DFF00",
                borderWidth: 1,
                pointRadius: 0,
              },
            ],
          };

          setChartData(newChartData);
          setPriceGridData(datas);
        }
      });
    }
  };

  const companyInfo = () => {
    if (api !== undefined && api !== "") {
      api.snaphotCardFieldsGet("sec.101.837", selectedLang).then((response) => {
        if (response.status === 200) {
          let datas = response.data;
          if (selectedLang === "en-US") {
            datas.map((item) => {
              item.name = item.name.replace("TL", "TRY");
              item.name = item.name.replace("mn, TRY", "TRY, mn");
              item.name = item.name.replace("mn, USD", "USD, mn");
            });
          } else if (selectedLang === "tr-TR") {
            datas.map((item) => {
              item.name = item.name.replace("mln, TL", "TL, mln");
              item.name = item.name.replace("mln, USD", "USD, mln");
            });
          }
          const sortedDatas = datas.sort((a, b) => a.order - b.order);

          setCompanyInformation(sortedDatas);
        }
      });
    }
  };

  const netAssetValueFunction = () => {
    if (api !== undefined && api !== "") {
      api
        .snaphotNavChartExcelGet(selectedCurrency["name"])
        .then((response) => {
          if (response.status === 200) {
            let datas = response.data;

            let data1 = [];
            let label = [];

            const processedData = datas.map((item, index, arr) => {
              const isLast = index === arr.length - 1;
              return {
                quarter: isLast ? item.quarter : item.quarter.slice(0, -2),
                value: formatNumberDigits(parseFloat(item.value)),
              };
            });
            for (var i = 0; i < processedData.length; i++) {
              data1.push(parseFloat(processedData[i]["value"]));
              label.push(processedData[i]["quarter"]);
            }

            const newChartData = {
              labels: label,
              datasets: [
                {
                  data: data1,
                  fill: false,
                  borderColor: "#D5B555",
                  borderWidth: 1,
                  pointRadius: 0,
                },
              ],
            };
            setNavData(newChartData);
          }
        });
    }
  };

  const newsDatas = () => {
    if (api !== undefined && api !== "") {
      let sDate = moment(startDate).format("yyyy-MM-DD");
      let eDate = moment(endDate).format("yyyy-MM-DD");

      api
        .snaphotNewsGet("sec.101.837", selectedLang, sDate, eDate, 20, 0)
        .then((response) => {
          if (response.status === 200) {
            let datas = response.data;
            setNewsData(datas);
          }
        });
    }
  };
  //#endregion

  //#region Other Function
  const frequencyFunction = (e, fr) => {
    setFrequency(fr);

    let items = document.querySelectorAll("#chart-dates .list-inline-item");
    items.forEach((s) => {
      if (s.childNodes[0].classList.contains("selected")) {
        s.childNodes[0].classList.remove("selected");
      }
    });
    e.target.classList.add("selected");
  };

  const handlePage = () => {
    indexCoverageInformation();
    companyInfo();
  };
  //#endregion

  //#region Change Date
  const startDateChange = (e) => {
    if (e > endDate) {
      setStartDate(endDate);
      setEndDate(e);
    } else setStartDate(e);
  };

  const endDateChange = (e) => {
    if (e < startDate) {
      setEndDate(startDate);
      setStartDate(e);
    } else setEndDate(e);
  };
  //#endregion

  //#region Footer Content
  const footerContent = (
    <div>
      <Button
        className="o-custom-button btn btn-secondary"
        onClick={() => setVisible(false)}
      >
        <i className="fas fa-times align-middle"></i> <span>{t("Close")}</span>
      </Button>
    </div>
  );
  //#endregion

  //#region UseEffect
  useEffect(() => {
    if (window.location.pathname.indexOf("snapshot") !== -1) {
      i18n.changeLanguage("en");
      setDate(moment(new Date()).format("MM/DD/YYYY"));
      setSelectedLang("en-US");
      setNewsStatu(false);
      setCurrencies([
        { name: "TRL", code: "Turkish Lira" },
        { name: "USD", code: "Dollar" },
        { name: "EUR", code: "Euro" },
      ]);
      setSelectedCurrency({ name: "EUR", code: "Euro" });
    } else {
      setDate(moment(new Date()).format("MM/DD/YYYY"));
      setSelectedLang("tr-TR");
      setNewsStatu(true);
      setCurrencies([
        { name: "TRL", code: "Türk Lirası" },
        { name: "USD", code: "Dolar" },
        { name: "EUR", code: "Euro" },
      ]);
      setSelectedCurrency({ name: "EUR", code: "Euro" });
    }
  }, []);

  useEffect(() => {
    priceChartData(frequency);
  }, [frequency]);

  useEffect(() => {
    if (selectedCurrency !== null && selectedCurrency !== undefined)
      netAssetValueFunction();
  }, [selectedCurrency]);

  useEffect(() => {
    if (selectedLang !== "") {
      handlePage();

      setChartOptions({
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            intersect: false,
            mode: "index",
            callbacks: {
              label: (tooltipItem) => {
                if (selectedLang === "tr-TR") {
                  return formatNumber(tooltipItem.raw, 2, selectedLang) + " TL";
                } else {
                  return (
                    formatNumber(tooltipItem.raw, 2, selectedLang) + " TRY"
                  );
                }
              },
              title: (tooltipItems) => {
                const date = new Date(tooltipItems[0].parsed.x);
                if (selectedLang === "tr-TR") {
                  return new Intl.DateTimeFormat("tr-TR", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  }).format(date);
                } else {
                  return new Intl.DateTimeFormat("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  }).format(date);
                }
              },
            },
          },
        },
        scales: {
          x: {
            type: "time",
            distribution: "linear",
            grid: {
              display: false,
            },
            ticks: {
              callback: (value, index, ticks) => {
                const date = new Date(value);
                if (selectedLang === "tr-TR") {
                  return new Intl.DateTimeFormat("tr-TR", {
                    year: "numeric",
                    month: "short",
                  }).format(date);
                } else {
                  return new Intl.DateTimeFormat("en-US", {
                    year: "numeric",
                    month: "short",
                  }).format(date);
                }
              },
              font: {
                color: "#000",
                size: 13,
              },
            },
            time: {
              unit: "month",
            },
          },
          y: {
            grid: {
              color: "#E1E2E2",
            },
            ticks: {
              callback: function (value, index, ticks) {
                return formatNumber(value, 2, selectedLang);
              },
              font: {
                color: "#000",
                size: 12,
              },
              padding: 15,
            },
            beginAtZero: false,
          },
        },
      });
    }
  }, [selectedLang]);

    useEffect(() => {
    if (
      selectedLang !== "" &&
      startDate !== undefined &&
      endDate !== undefined
    ) {
      newsDatas();
    }
  }, [startDate, endDate, selectedLang]);
  //#endregion

  return (
    <>
      <div className="snapshotComponent">
        <div className="header mb-4">{t("headerTitle")}</div>

        <div className="row mb-2">
          <div className="col-12 col-lg-6">
            <div className="row">
              <div className="col-12">
                <div className="title mb-4">
                  {t("pricePerformance")}
                  <i
                    className="fa fa-th float-end"
                    onClick={() => setChartStatu(!chartStatu)}
                  ></i>
                </div>
                <div className="chartArea">
                  <div className={`row ${chartStatu ? "" : "d-none"}`}>
                    <div className="col-md-12 text-end rt-item">
                      <ul
                        id="chart-dates"
                        className="list-inline m-0 chart-period-btn mb-3"
                      >
                        {frequencies.map(({ value, label }) => (
                          <li
                            key={value}
                            className="list-inline-item"
                            onClick={(e) => frequencyFunction(e, value)}
                          >
                            <Link
                              data-date={value}
                              className={`btn btn-block ${
                                value === "1y" ? "selected" : ""
                              }`}
                            >
                              {value === "1y"
                                ? "1y"
                                : value === "2y"
                                ? "2y"
                                : value === "3y"
                                ? "3y"
                                : value === "5y"
                                ? "5y"
                                : `${value.charAt(0)}${label}`}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div
                      style={{ width: "100%", height: "100%" }}
                      className=" d-block"
                    >
                      <Line
                        className="mb-5"
                        ref={chartRef}
                        data={chartData}
                        height={95}
                        options={chartOptions}
                      />
                    </div>
                  </div>
                  <div className={`row ${chartStatu ? "d-none" : ""}`}>
                    <div className="col-md-12">
                      <div className="gridTable mb-2">
                        <table className="table grid w-100">
                          <thead>
                            <tr>
                              <th>{t("date")}</th>
                              <th>{t("data")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {priceGridData?.map((item, index) => (
                              <tr key={index}>
                                <td>
                                  {moment(item.date).format("DD.MM.yyyy")}
                                </td>
                                <td>{formatNumber(parseFloat(item.value))}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="title mb-4">{t("netAssetValue")}</div>
                <div className="chartArea">
                  <div className={`row`}>
                    <div className="col-md-12 text-end rt-item position-relative">
                      <label className="inputLabel">{t("currency")}</label>
                      <Dropdown
                        value={selectedCurrency}
                        onChange={(e) => {
                          setSelectedCurrency(e.value);
                        }}
                        options={currencies}
                        optionLabel="code"
                        className=" customDropdown"
                        panelClassName="customDropdownPanel"
                      />
                    </div>
                    <div
                      style={{ width: "100%", height: "100%" }}
                      className=" d-block"
                    >
                      <Line
                        ref={navChartRef}
                        data={navData}
                        height={95}
                        options={navChartOptions}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-6">
            <div className="title">
              {t("companyInformation")}
              <span className="date float-end spacing-0">
                {moment(date).format("DD.MM.yyyy")}
              </span>
            </div>
            <table className="table compancyCard w-100">
              {companyInformation !== undefined &&
                companyInformation.length > 0 && (
                  <tbody>
                    <tr>
                      <td>{selectedLang === "en-US" ? "Sector" : "Sektör"}</td>
                      <td>{selectedLang === "en-US" ? "REIT" : "GYO"}</td>
                    </tr>
                    <tr>
                      <td>
                        {selectedLang === "en-US" ? "Ticker" : "Borsa Kodu"}
                      </td>
                      <td>AKFGY</td>
                    </tr>
                    {companyInformation.map((item, key) => (
                      <tr key={key}>
                        <td>
                          {selectedLang === "en-US"
                            ? item.name.replace("TL", "TRY")
                            : item.name}
                        </td>
                        <td className="table-value">
                          {formatNumber(parseFloat(item.value))}
                        </td>
                      </tr>
                    ))}
                    {/* <tr>
                      <td>Ortalama Fiyat (1 aylık TL)</td>
                      <td>2.52</td>
                    </tr>
                    <tr>
                      <td>Ortalama Adet (6 aylık, mln)</td>
                      <td>42.84</td>
                    </tr> */}
                  </tbody>
                )}
            </table>
          </div>
        </div>

        <div className={`row mb-5 ${newsStatu ? "" : "d-none"}`}>
          <div className="col-md-12">
            <div className="title mb-3">{t("kapNews")}</div>
            <div className="dateArea mb-3">
              <div className="firstDate d-inline-block me-3">
                <CalendarComponent date={startDate} change={startDateChange} />
              </div>
              <div className="lastDate d-inline-block">
                <CalendarComponent date={endDate} change={endDateChange} />
              </div>
            </div>
            <div className="news d-inline-block position-relative w-100">
              <table className="w-100">
                <tbody>
                  {newsData?.map((item, index) => (
                    <tr
                      key={index}
                      onClick={() => {
                        openNewsDetail(item);
                      }}
                    >
                      <td>{moment(item.date).format("DD.MM.yyyy hh:mm:ss")}</td>
                      <td>{item.header}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="row mb-3 mt-3">
          <div className="col-md-12">
            <div className="title mb-3">{t("indexCoverage")}</div>
            <div className="indexWeightTable d-inline-block position-relative w-100">
              <table className="table indexWeight w-100">
                <thead>
                  <tr>
                    <th>{t("index")}</th>
                    <th>{t("weight")}</th>
                  </tr>
                </thead>
                <tbody>
                  {indexData?.map((item, index) => (
                    <tr key={index}>
                      <td>{item.name}</td>
                      <td className="table-value">
                        {formatNumber(parseFloat(item.value))}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="note text-end d-inline-block w-100">
              {t("noteSnapshotFinancial")}
            </div>
            <div className="note text-end d-inline-block w-100">
              {t("noteSnapshot")}
            </div>
            <div
              className={`copyright text-end d-inline-block w-100 position-relative mb-4 ${
                selectedLang !== "tr-TR" ? "d-none" : ""
              }`}
            >
              *** Piyasa verileri
              <Link to="https://www.rasyonet.com.tr/tr" target="_blank">
                <img src={RasyonetLine} />
              </Link>
              tarafından sağlanmaktadır.
            </div>
            <div
              className={`copyright text-end d-inline-block w-100 position-relative mb-4 ${
                selectedLang === "tr-TR" ? "d-none" : ""
              }`}
            >
              *** The share information data is provided by{" "}
              <Link to="https://www.rasyonet.com.tr/en" target="_blank">
                <img src={RasyonetLine} />
              </Link>
            </div>
          </div>
        </div>
      </div>
      <Dialog
        header="Haber Detayı"
        visible={visible}
        style={{ width: "50vw" }}
        onHide={() => setVisible(false)}
        footer={footerContent}
      >
        <div id="newsModalHeader" className="mb-2"></div>
        <div id="newsModalHeaderDate" className="mb-3"></div>
        <div id="newsModalHeaderProvider"></div>

        <div className="col-md-12" id="newsModalScrollDiv">
          <div id="newsModalBody" className=""></div>
        </div>
      </Dialog>
    </>
  );
}

export default Snapshot;
